export default {
  authenticated: false,
  token: null,
  userData: {},
  userRoles: [],
  lastPath: null
}
